import { faArrowLeft, faArrowRight, faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";

function Paginator({ totalItems, itemsPerPage, currentPage, onPageChange }) {
  const [internalPage, setInternalPage] = useState(1);
  const controlled = currentPage !== undefined;
  const page = controlled ? currentPage : internalPage;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handleChange = (next) => {
    if (!controlled) setInternalPage(next);
    onPageChange(next);
  };

  // Función para ir a la página anterior
  const goToPreviousPage = () => {
    if (page > 1) {
      handleChange(page - 1);
    }
  };

  // Función para ir a la página siguiente
  const goToNextPage = () => {
    if (page < totalPages) {
      handleChange(page + 1);
    }
  };

  return (
    <div className="d-flex justify-content-end align-items-center paginator">
      <span>Página {page} de {totalPages}</span>
      <button onClick={goToPreviousPage} disabled={page === 1}><FontAwesomeIcon icon={faChevronLeft} /></button>
      <button onClick={goToNextPage} disabled={page === totalPages}><FontAwesomeIcon icon={faChevronRight} /></button>
    </div>
  );
}

export default Paginator;